import React, { useState } from 'react';
import Layout from "./layout";
import Footer from './footer';
import BgImage from '../images/bg/pragicts-featured-projects.jpg';
import empl from '../images/projects/empl.png';
import mybiz from '../images/projects/mybiz.png';
import html from '../images/stack_logo/html.png';
import css from '../images/stack_logo/css.png';
import aws from '../images/stack_logo/aws.png';
import google from '../images/stack_logo/google.png';
import js from '../images/stack_logo/js.png';
import bg from '../images/projects/bg.jpg';

const projects = [
  { 
    id: 1, 
    date: "Wednesday, April 03, 2024",
    title: "Information Technology Infrastructure Library (ITIL), A Must for IT Operations", 
    image: bg, 
    description: `ITIL is a globally recognized framework that standardizes the selection, planning, delivery, and maintenance of IT services within a business. It is a framework designed to standardize IT service management practices, ensuring efficient service delivery aligned with business goals and aims to enhance efficiency, ensure predictable service delivery, and align IT activities with business requirements.<br><br>
    By adopting ITIL, organizations can transform IT administrators into strategic business partners rather than just support staff.<br><br>
    
    01 Strategies<br><br>
    ITIL emphasizes several strategic aspects:<br><br>
    - Value - ITIL encourages organizations to focus on delivering value to customers and stakeholders.<br><br>
    - Collaboration - Effective communication and collaboration between IT and other business units are essential.<br><br>
    - Process Optimization - ITIL promotes continuous improvement of IT processes.<br><br>
    
    02 Standards<br><br>
    ITIL provides guidelines to align IT services with business objectives for consistent delivery.<br><br>
    
    03 Service Lifecycle<br><br>
    - Service Strategy: Aligning IT services with business objectives.<br>
    - Service Design: Designing effective and efficient IT services.<br>
    - Service Transition: Managing changes to IT services.<br>
    - Service Operations: Ensuring IT services are delivered and supported effectively.<br>
    - Continual Service Improvement: Continuously enhancing IT services to meet evolving business needs.<br><br>
    
    04 Documentations<br><br>
    (a) Roles and Responsibilities: ITIL defines roles like Incident Manager, Problem Manager, Change Manager, and Service Level Manager.<br><br>
    (b) Certifications: ITIL offers certifications validating expertise in IT service management.<br><br>
    (c) Lifecycle Phases: ITIL includes phases like Service Strategy, Design, Transition, Operation, and Continual Improvement.<br><br>
    
    Benefits<br><br>
    - Cost Efficiency: ITIL helps in reducing costs associated with IT services.<br>
    - High Service Quality: ITIL promotes the delivery of high-quality IT services.<br>
    - Increased Productivity: ITIL enhances business productivity through streamlined IT processes.<br>
    - Improved ROI: ITIL contributes to better returns on IT investments.<br>
    - Enhanced Customer Satisfaction: ITIL focuses on meeting customer needs and expectations.<br>
    - Optimized Resource Utilization: ITIL ensures the efficient use of IT resources.<br><br>
    
    A Brief History of ITIL<br><br>
    Initially developed by the UK government's Central Computer and Telecommunications Agency (CCTA) in the 1980s, ITIL aimed to standardize IT practices across government agencies. Over time, ITIL evolved into a globally recognized best-practice standard for ITSM, focusing on delivering efficient and high-quality IT services aligned with business objectives. The framework has undergone several updates and revisions, with the latest version being ITIL 4.<br><br>
    
    ITIL V1: ITIL was created in 1989 to standardize IT service management.<br><br>
    ITIL V2: It was introduced in 2001 to perform a uniform structure for service delivery.<br><br>
    ITIL V3: It was updated in 2007 with a feedback looping feature in order to improve ITIL service.<br><br>
    
    Lifecycle<br><br>
    ITIL V3 2011: It was released in 2011. It is an upgraded version of V3 and clarifies processes of ITIL V3.<br><br>
    
    …………………………………………………………………………………………………………………..<br><br>
    
    ITIL V4: It has been released in 2019. It has a flexible and integrated system for effective management of IT-enabled services.<br><br>
    
    ITIL 4 consists of two components:<br><br>
    
    (1) The four dimensions model<br>
    (2) ITIL service value system<br><br>
    
    The four dimensions model:<br><br>
    An organization should address all four dimensions in order to maintain the service quality.<br><br>
    
    - Organizations and People: People in the organization should understand their roles and responsibilities towards creating value for the organization.<br>
    - Information and Technology: This includes the information, knowledge, and techniques that are required for managing services.<br>
    - Partners and Suppliers: It incorporates contracts and other agreements between organizations and their partners.<br>
    - Value streams and Processes: A value stream is a series of steps that an organization uses to create and deliver products and services to a consumer, whereas a well-defined process can improve productivity within or across organizations.<br><br>
    
    ITIL service value system:<br><br>
    
    The service value system (SVS) is a set of activities performed by an organization to deliver a valuable output to end-users.<br><br>
    
    The ITIL 4 SVS includes several elements:<br><br>
    
    - Guiding principles: It has a set of principles that guide you by creating value for your customers and your organization.<br>
    - Governance: It controls and monitors the performance of the organization.<br>
    - Service value chain: It is a set of activities that a business performs in order to deliver a valuable product or service to its consumers.<br>
    - Continual improvement: It is an iterative approach that ensures that an organization's performance meets customer expectations.<br>
    - Practices: It has 34 management practices that are designed for accomplishing organizational goals.<br><br>
    `,
  },
  { 
    id: 2, 
    date: "Wednesday, April 03, 2024",
    title: "Top Use Cases for Firewalls", 
    image: bg, 
    description: `Firewalls play a pivotal role in network and cybersecurity, offering essential protection against a wide range of threats. Here's a concise overview of their top use cases:<br><br>
    1.   Perimeter Protection: Firewalls establish a barrier between internal networks and the Internet, filtering incoming and outgoing traffic based on predefined rules. These rules can include protocol, IP, port, application, time, and bandwidth filtering, allowing only authorized traffic to pass through.<br><br>
    
    2.   Access Control: Firewalls enable granular control over network resource access, essential for maintaining data confidentiality and meeting compliance requirements.<br><br>
    
    3.   Intrusion Prevention System (IPS): Firewalls equipped with IPS functionality actively identify and block malicious activities in real-time, including known attacks and zero-day exploits.<br><br>
    
    4.   Virtual Private Network (VPN) Enforcement: Firewalls often serve as gateways for VPN connections, providing secure access to internal network resources for remote users or branch offices. They authenticate and encrypt VPN traffic, ensuring data remains protected during transmission over untrusted networks.<br><br>
    
    5.   Content Filtering: Firewalls can filter web content based on predefined criteria such as website categories, URLs, or keywords. This allows organizations to enforce acceptable use policies and block access to inappropriate or malicious websites, reducing the risk of malware infections or data breaches.<br><br>
    
    6.   Data Loss Prevention (DLP): Some firewalls incorporate DLP features to monitor and prevent the unauthorized transmission of sensitive data outside the organization's network. They inspect outbound traffic for patterns or keywords indicating confidential information and take action to prevent data leaks.<br><br>
    
    7.   Threat Intelligence Integration: Firewalls leverage threat intelligence feeds to proactively detect and respond to emerging threats, enhancing cybersecurity posture.<br><br>
    
    Overall, firewalls are critical components of network security infrastructure, helping organizations mitigate risks, protect sensitive data, and maintain compliance with regulatory requirements.<br>`, 
  },
  { 
    id: 3, 
    date: "Saturday, March 30, 2024",
    title: "Cybersecurity, The Nuts And Bolts", 
    image: bg, 
    description: `SOME FACTS<br><br>
A cyberattack strikes every 39 seconds!<br><br>

In 2024, the global cost of cybercrime is projected to reach a staggering USD 9.5 trillion, emphasizing the urgent need for cybersecurity to be a top global priority.<br><br>

With the proliferation of generative AI, including technologies like ChatGPT, the current daily average of 2,200 cyberattacks is expected to escalate significantly, becoming more personalized and widespread.<br><br>

Despite technological advancements, ransomware is anticipated to remain a predominant threat in 2024. According to Statista, it accounted for over 72% of cybersecurity incidents in 2023. Furthermore, small and medium-sized businesses (SMBs) are increasingly becoming targets, with 61% falling victim to cyberattacks in 2023. This has led to a projected growth of the global cybersecurity market to $266.2 billion by 2027.<br><br>

In 2023, there were 2,365 cyberattacks, impacting a staggering 343,338,964 individuals. Data breaches surged by 72% between 2021 and 2023, surpassing previous records.<br><br>

Email remains the most common avenue for malware, with approximately 35% of malware deliveries occurring via email in 2023. Moreover, over 94% of organizations reported incidents related to email security.<br><br>

The financial fallout from cyberattacks is significant, with the average data breach costing $4.45 million. In 2022 alone, business email compromises led to losses totaling $2.7 billion. These figures underscore the critical imperative to address cyber vulnerabilities and cultivate a skilled cybersecurity workforce, especially as our society becomes increasingly reliant on digital technologies and interconnectedness.<br><br>

TYPE OF THREATS<br><br>
01 Malware<br><br>
Malware, short for "malicious software," encompasses various harmful programs designed to exploit or damage programmable devices, services, or networks. Nearly all modern cyberattacks involve some form of malware. Threat actors employ malware to gain unauthorized access, render systems inoperable, destroy data, steal sensitive information, and compromise critical files.<br><br>

Common types of malware include:<br><br>

Ransomware: Encrypts a victim's data or device and demands a ransom for its release.<br><br>

Trojan Horse: Deceptive code disguised as legitimate software to trick users into downloading and installing it, often leading to further malware infiltration.<br><br>

Spyware: Covertly collects sensitive information from a device and transmits it to the attacker without the user's knowledge.<br><br>

Worms: Self-replicating programs that propagate across devices and networks autonomously.<br><br>

02 Phishing/Social Engineering Scams<br><br>
Phishing, the most widespread form of social engineering, involves fraudulent emails, attachments, text messages, or calls aimed at deceiving individuals into disclosing personal data, downloading malware, transferring funds to cybercriminals, or engaging in other actions that compromise their security.<br><br>

Common phishing tactics include:<br><br>

Spear Phishing: Targeted attacks tailored to specific individuals, often leveraging information from public social media profiles.<br><br>

Business Email Compromise (BEC): Scams impersonating executives or trusted contacts to deceive victims into divulging sensitive information or wiring money.<br><br>

Domain Name Spoofing: Creation of fake websites or domains resembling legitimate ones to trick users into divulging sensitive information.<br><br>

03 Man-in-the-Middle (MITM) Attacks<br><br>
MITM attacks involve intercepting and manipulating communications between two parties to steal data. Hackers exploit vulnerabilities in unsecured Wi-Fi networks to eavesdrop on connections and extract sensitive information.<br><br>

04 Denial-of-Service (DoS) Attacks<br><br>
DoS attacks overwhelm websites, applications, or systems with fraudulent traffic, rendering them slow or inaccessible to legitimate users. Distributed Denial-of-Service (DDoS) attacks amplify this by utilizing botnets to inundate targets with malicious traffic.<br><br>

05 Zero-Day Exploits<br><br>
Zero-day exploits target previously unknown vulnerabilities in software, hardware, or firmware. Hackers exploit these flaws before vendors can develop patches or fixes, enabling unauthorized access to vulnerable systems.<br><br>

06 Password Attacks<br><br>
Cybercriminals attempt to guess or steal passwords and login credentials to gain unauthorized access to user accounts. These attacks may involve social engineering tactics or brute force techniques.<br><br>

07 Internet of Things (IoT) Attacks<br><br>
IoT attacks exploit vulnerabilities in connected devices, such as smart home gadgets and industrial systems, to compromise security, steal data, or orchestrate larger cyberattacks.<br><br>

08 Injection Attacks<br><br>
Injection attacks involve injecting malicious code into programs or systems to execute remote commands, manipulate databases, or alter website data. Common types include SQL injection and Cross-Site Scripting (XSS) attacks.<br><br>

TYPE OF PERPETRATORS<br><br>
01 Cybercriminals<br><br>
Cybercriminals are individuals or groups who engage in illegal activities primarily for financial gain. They perpetrate various cybercrimes, including ransomware attacks and phishing scams aimed at extorting money or obtaining sensitive information such as credit card details, login credentials, or intellectual property.<br><br>

02 Hackers<br><br>
Hackers possess technical expertise to infiltrate computer networks or systems. It's important to note that not all hackers are malicious actors; some, known as ethical hackers, assist organizations and government agencies by identifying vulnerabilities in their systems to enhance cybersecurity defenses.<br><br>

03 Nation-State Actors<br><br>
Nation-states and governmental entities often sponsor threat actors to conduct cyber espionage, gather confidential data, or disrupt critical infrastructure of other nations. These activities, which may include espionage or cyberwarfare, are well-funded and sophisticated, posing significant challenges for detection and mitigation.<br><br>

04 Insider Threats<br><br>
Insider threats involve individuals within an organization who pose risks to its cybersecurity, whether intentionally or unintentionally. While some insider threats stem from human error, such as inadvertently installing malware or losing company-issued devices, others result from malicious actions. Disgruntled employees, for instance, may exploit their access privileges for personal gain or to inflict harm on the organization, either financially or reputational.<br><br>

PROTECTION<br><br>
01 Strong Passwords<br><br>
Utilize strong, unique passwords for all accounts and systems, incorporating a mix of uppercase and lowercase letters, numbers, and symbols. Regularly update passwords and avoid using easily guessable information like birthdays or common phrases.<br><br>

02 Email Security Tools<br><br>
Implement email security solutions to detect and block phishing attempts, malware-laden attachments, and suspicious links. Train employees to recognize phishing emails and exercise caution when interacting with unfamiliar or unexpected messages.<br><br>

03 Antivirus Software<br><br>
Install reputable antivirus software on all devices to detect and remove malicious software, including viruses, Trojans, and spyware. Keep antivirus programs up-to-date to ensure they can identify emerging threats effectively.<br><br>

04 Firewalls and VPNs<br><br>
Deploy firewalls to monitor and control incoming and outgoing network traffic, preventing unauthorized access and filtering out malicious data packets. Additionally, use Virtual Private Networks (VPNs) to encrypt internet connections and safeguard sensitive data transmitted over public networks.<br><br>

05 Multi-Factor Authentication (MFA)<br><br>
Enable MFA wherever possible to add an extra layer of security beyond passwords. Require users to provide additional verification, such as a one-time code sent to their mobile device, before accessing accounts or systems.<br><br>

06 Cybersecurity Training<br><br>
Educate employees about common cyber threats, phishing techniques, and best practices for cybersecurity hygiene. Regular training sessions can help cultivate a culture of security awareness and empower individuals to recognize and respond to potential threats effectively.<br><br>

07 Advanced Endpoint Security<br><br>
Employ advanced endpoint security solutions, such as endpoint detection and response (EDR) platforms, to proactively identify and mitigate threats across devices and endpoints. These tools offer real-time monitoring, threat intelligence, and automated response capabilities.<br><br>

08 Threat Detection and Incident Response<br><br>
Invest in state-of-the-art threat detection and incident response capabilities to identify cybersecurity threats in real-time. Develop and regularly test incident response plans to enable swift and effective responses to cyber incidents, minimizing potential damage and disruption.<br><br>

By implementing these proactive measures and fostering a security-conscious culture, organizations can significantly enhance their resilience against cyber threats and mitigate the risks associated with cyberattacks.<br>
`, 
  },
  { 
    id: 4, 
    date: "Wednesday, March 27, 2024",
    title: "AI, is it fast getting commoditized? Where will the edge be?", 
    image: bg, 
    description: `Artificial intelligence (AI) is progressively transitioning into a commodity, characterized by increased accessibility and integration into diverse products and services. These AI offerings are being bundled and presented as services, making them easily available to both businesses and individuals.<br><br>

The availability of AI services on cloud computing platforms allows users to tap into pre-trained models, facilitating the development of applications without the need to start from scratch. This commoditization of AI services is breaking down entry barriers, enabling businesses of varying sizes to seamlessly integrate AI into their operations without significant upfront investments in expertise or infrastructure. Furthermore, many companies now provide ready-made AI solutions tailored for specific industries or use cases, reinforcing the perception of AI as a commodity. This trend is expected to persist as AI technologies mature, becoming even more user-friendly and accessible.<br><br>

As AI becomes a common factor, a level playing field is inevitable. In such a scenario, differentiation from competitors becomes a critical consideration.<br><br>

The solution, it seems, lies in the timeless realm of human ingenuity, ushering in the next cycle of innovation and distinctiveness. In navigating the landscape of ubiquitous AI, organizations can rely on the creative and problem-solving capabilities of human minds to pioneer new ideas, approaches, and applications, thereby setting themselves apart from the competition.<br>
`, 
  },
  { 
    id: 5, 
    date: "Wednesday, March 27, 2024",
    title: "Cyber Security is not simple.", 
    image: bg, 
    description: `Cyber security is not simple. It is beyond a single vendor/product solution and/or an ad hoc approach.<br><br>

Cybersecurity requires a comprehensive approach because the digital landscape is complex and dynamic, with a multitude of potential threats and vulnerabilities. A comprehensive cybersecurity strategy considers the various aspects of information security to create a robust defense against a wide range of cyber threats.<br><br>

Here are some reasons why a comprehensive approach is necessary:<br><br>

<b>Diverse Threat Landscape</b><br>
Cyber threats come in various forms, such as malware, ransomware, phishing attacks, and more.<br><br>

<b>Multiple Attack Vectors</b><br>
Cyberattacks can target different entry points, including networks, endpoints, applications, and human users.<br><br>

<b>Interconnected Systems</b><br>
Modern organizations rely on interconnected systems and networks, making them susceptible to cascading effects if one component is compromised.<br><br>

<b>Dynamic Technology Landscape</b><br>
Technology evolves rapidly, introducing new devices, applications, and platforms.<br><br>

<b>Human Factor</b><br>
Employees and users are often targets for cyber attackers through social engineering and other tactics.<br><br>

<b>Data Sensitivity</b><br>
Organizations handle sensitive and valuable data that requires protection.<br><br>

<b>Regulatory Compliance</b><br>
Different industries and regions have specific cybersecurity regulations and compliance requirements.<br><br>

<b>Third-Party Risks</b><br>
Many organizations rely on third-party vendors and service providers, introducing additional security risks.<br><br>

<b>Incident Response and Recovery</b><br>
Despite preventive measures, security incidents may still occur.<br><br>

<b>Continuous Monitoring</b><br>
Cyber threats are persistent and continually evolving.<br><br>

<b>Resource Allocation</b><br>
Limited resources require prioritization and efficient use.<br><br>

<b>Organizational Resilience</b><br>
Cybersecurity is not only about preventing breaches but also about ensuring the organization's resilience in the face of attacks.<br><br>

In summary, a comprehensive cybersecurity approach recognizes the multifaceted nature of cyber threats and takes a layered, adaptive, and strategic approach to protect an organization's digital assets, systems, and information.<br><br>

Developing a robust cybersecurity strategy involves a multi-faceted approach that addresses various aspects of information security.<br><br>

<b>Risk Assessment</b><br>
Identify and assess potential cybersecurity risks specific to your organization. Evaluate the potential impact and likelihood of various threats. Prioritize risks based on their significance to your business.<br><br>

<b>Security Policies and Procedures</b><br>
Establish clear and comprehensive security policies and procedures. Define acceptable use of technology and data handling guidelines. Communicate these policies to all employees and stakeholders.<br><br>

<b>Employee Training and Awareness</b><br>
Conduct regular cybersecurity awareness training for all employees. Educate staff about the latest threats, phishing scams, and social engineering tactics. Foster a culture of security awareness throughout the organization.<br><br>

<b>Access Control</b><br>
Implement the principle of least privilege, ensuring users have only the necessary access. Regularly review and update user access permissions. Utilize strong authentication methods, such as multi-factor authentication.<br><br>

<b>Network Security</b><br>
Deploy firewalls, intrusion detection/prevention systems, and secure gateways. Regularly update and patch network devices and software. Monitor network traffic for unusual or suspicious activities.<br><br>

<b>Endpoint Security</b><br>
Install and regularly update antivirus, anti-malware, and endpoint protection software. Encrypt sensitive data on endpoints. Implement device management and control policies.<br><br>

<b>Data Protection</b><br>
Classify and encrypt sensitive data. Regularly back up critical data and ensure data recovery processes are in place. Establish data retention and disposal policies.<br><br>

<b>Incident Response and Recovery</b><br>
Develop an incident response plan outlining steps to take in the event of a security incident. Conduct regular drills and simulations to test incident response capabilities. Establish a clear recovery process to minimize downtime and data loss.<br><br>

<b>Security Audits and Assessments</b><br>
Conduct regular security audits and assessments. Engage third-party penetration testers to identify vulnerabilities. Stay informed about emerging threats and vulnerabilities.<br><br>

<b>Vendor Security</b><br>
Assess and ensure the security practices of third-party vendors. Include cybersecurity clauses in contracts with service providers. Regularly monitor and audit vendor security practices.<br><br>

<b>Regulatory Compliance</b><br>
Stay compliant with relevant data protection and privacy regulations. Understand and adhere to industry-specific cybersecurity standards. Regularly review and update compliance measures.<br><br>

<b>Continuous Monitoring and Improvement</b><br>
Implement continuous monitoring of systems and networks. Regularly update and improve security measures based on the evolving threat landscape. Stay informed about the latest cybersecurity trends and technologies.<br>
`, 
  },
  { 
    id: 6, 
    date: "Wednesday, March 27, 2024",
    title: "Automation, Why it is an essential milestone to achieve.", 
    image: bg, 
    description: `Digitization has profoundly and widely impacted the world across various sectors.<br><br>

<b>Global Connectivity</b><br>
The internet has connected people worldwide, facilitating communication, collaboration, and information sharing on a global scale.<br>
According to the GSMA's annual State of Mobile Internet Connectivity Report 2023, over half (54%) of the global population, some 4.3 billion people now own a smartphone. Global Internet penetration is tipping over 65.7%.<br><br>

<b>Economic Impact</b><br>
Digitization has transformed economies, fostering the growth of digital industries, e-commerce, and online marketplaces.<br><br>

<b>Education</b><br>
Digital technologies have revolutionized education, providing access to online courses, virtual classrooms, and educational resources globally.<br><br>

<b>Healthcare</b><br>
Digitization in healthcare includes electronic health records, telemedicine, health apps, and data-driven diagnostics, improving patient care and accessibility.<br><br>

<b>Communication</b><br>
Digital communication tools, including email, social media, and messaging apps, have revolutionized the way people connect and share information.<br><br>

<b>Finance and Banking</b><br>
Digital banking services, online transactions, and financial technologies (fintech) have transformed the financial sector, making services more accessible and efficient.<br><br>

<b>Smart Cities</b><br>
Digitization contributes to the development of smart cities, incorporating technology to enhance urban living, improve infrastructure, and optimize resource management.<br><br>

<b>Business and Industry</b><br>
Industries leverage digital technologies for automation, data analytics, and supply chain optimization, enhancing efficiency and productivity.<br><br>

<b>Entertainment and Media</b><br>
Streaming services, digital content platforms, and online gaming have changed the way people consume entertainment and media globally.<br><br>

<b>Government Services</b><br>
Many governments have embraced digitization to provide online services, facilitate e-governance, and enhance transparency.<br><br>

<b>Agriculture</b><br>
Digital technologies, such as precision farming, IoT (Internet of Things) sensors, and data analytics, contribute to modernizing agriculture practices for improved efficiency and sustainability.<br><br>

<b>Remote Work</b><br>
The COVID-19 pandemic accelerated the adoption of remote work, with digital tools enabling employees to work from anywhere.<br><br>

<b>Mobile Technology</b><br>
The widespread use of smartphones has facilitated access to digital services, information, and communication, especially in regions with limited traditional infrastructure.<br><br>

<b>Emerging Technologies</b><br>
Technologies like artificial intelligence (AI), blockchain, and the Internet of Things (IoT) continue to shape the digital landscape, opening up new possibilities and applications.<br><br>

<b>Social Impact</b><br>
Digitization has had social implications, influencing how people engage in civic activities, express opinions, and participate in online communities.<br><br>

The ongoing evolution of technology ensures that the reach and impact of digitization will continue to expand. It also creates a great extensive digital fabric for automation. Automation in general brings on board<br><br>

<b>Increased Efficiency</b><br>
Automation can perform repetitive tasks at a much faster pace than humans, leading to increased productivity and efficiency. This is particularly beneficial in manufacturing, data processing, and routine administrative tasks.<br><br>

<b>Cost Reduction</b><br>
Automated processes often result in reduced labor costs over time. While there may be initial investments in technology and infrastructure, the long-term savings in labor and operational costs can be significant.<br><br>

<b>Accuracy and Precision</b><br>
Automated systems can consistently perform tasks with high precision and accuracy. This is crucial in industries such as manufacturing and healthcare, where precision is paramount.<br><br>

<b>Improved Quality</b><br>
By minimizing human error, automation can enhance product and service quality. Automated processes follow predefined rules and specifications, reducing the likelihood of defects.<br><br>

<b>Enhanced Safety</b><br>
Automation is particularly valuable in environments that may pose safety risks to humans. Robots and automated machinery can handle dangerous tasks, reducing the likelihood of workplace accidents and injuries.<br><br>

<b>24/7 Operations</b><br>
Automated systems can operate around the clock without the need for breaks or shifts. This continuous operation can lead to increased output and faster turnaround times.<br><br>

<b>Scalability</b><br>
Automated systems can easily scale up or down based on demand. This flexibility allows businesses to adapt to changes in production requirements without the need for a significant adjustment in workforce size.<br><br>

<b>Data Collection and Analysis</b><br>
Automated systems generate vast amounts of data, which can be valuable for analysis and decision-making. This data-driven approach enables organizations to make informed strategic decisions.<br><br>

<b>Consistency in Processes</b><br>
Automation ensures that processes are consistently executed according to predefined standards. This is crucial in industries such as manufacturing and food production to maintain product consistency.<br><br>

<b>Competitive Advantage</b><br>
Organizations that leverage automation often gain a competitive edge by delivering products and services faster, more efficiently, and at a lower cost than competitors relying solely on manual processes.<br><br>

<b>Focus on Complex Tasks</b><br>
Automation allows humans to focus on more complex, creative, and cognitive tasks that require critical thinking, problem-solving, and emotional intelligence.<br><br>

<b>Mitigation of Workforce Challenges</b><br>
In certain industries facing labor shortages or challenges, automation can help fill the gaps, ensuring that critical tasks are still performed efficiently.<br>
`, 

  },
  { 
    id: 7, 
    date: "Wednesday, March 27, 2024",
    title: "Top Usecases for Firewalls", 
    image: bg, 
    description: `Firewalls play a pivotal role in network and cybersecurity, offering essential protection against a wide range of threats. Here's a concise overview of their top use cases:<br><br>

<b>1. Perimeter Protection:</b><br>
Firewalls establish a barrier between internal networks and the Internet, filtering incoming and outgoing traffic based on predefined rules. These rules can include protocol, IP, port, application, time, and bandwidth filtering, allowing only authorized traffic to pass through.<br><br>

<b>2. Access Control:</b><br>
Firewalls enable granular control over network resource access, essential for maintaining data confidentiality and meeting compliance requirements.<br><br>

<b>3. Intrusion Prevention System (IPS):</b><br>
Firewalls equipped with IPS functionality actively identify and block malicious activities in real-time, including known attacks and zero-day exploits.<br><br>

<b>4. Virtual Private Network (VPN) Enforcement:</b><br>
Firewalls often serve as gateways for VPN connections, providing secure access to internal network resources for remote users or branch offices. They authenticate and encrypt VPN traffic, ensuring data remains protected during transmission over untrusted networks.<br><br>

<b>5. Content Filtering:</b><br>
Firewalls can filter web content based on predefined criteria such as website categories, URLs, or keywords. This allows organizations to enforce acceptable use policies and block access to inappropriate or malicious websites, reducing the risk of malware infections or data breaches.<br><br>

<b>6. Data Loss Prevention (DLP):</b><br>
Some firewalls incorporate DLP features to monitor and prevent the unauthorized transmission of sensitive data outside the organization's network. They inspect outbound traffic for patterns or keywords indicating confidential information and take action to prevent data leaks.<br><br>

<b>7. Threat Intelligence Integration:</b><br>
Firewalls leverage threat intelligence feeds to proactively detect and respond to emerging threats, enhancing cybersecurity posture.<br><br>

Overall, firewalls are critical components of network security infrastructure, helping organizations mitigate risks, protect sensitive data, and maintain compliance with regulatory requirements.<br>
`, 
  },
  { 
    id: 8, 
    date: "Monday, March 25, 2024",
    title: "Demystifying Cyber Security", 
    image: bg, 
    description: `To start off with, what is cyber security?<br><br>

Cybersecurity is the practice of protecting internet-connected systems such as hardware, software, and data from cyber threats. It's used by individuals and enterprises to protect against unauthorized access to data centers and other computerized systems.<br><br>

The digital threat landscape is numerous, disruptive with innovation, competing technologies, choices, alternatives, active and hence fast-paced and unpredictable, and requires a cohesive approach which cannot simply depend on human effort alone to detect, isolate, and action for threat elimination.<br><br>

Comprehensive deployment of effective software tools (including AI and ML driven) are to be effectively capitalized to simplify the detection and actioning in real-time.<br><br>

Human intervention is sought on specific functions which require further analysis to formulate the course of action which are beyond the capabilities of the tools deployed.<br><br>

<b>Key Functions of Cyber Security on the digital platforms include:</b><br>
(1) Securing all end points (firewalls, access points, integration points, computing surfaces and devices, network equipment, etc.) with configurations with the required policies, restrictions, etc.<br><br>

(2) Unified Identity and access management. Ensure that all user accounts are managed in a granular fashion.<br><br>

(3) If the IT landscape under consideration is of a sizable proportion, then it demands the deployment of software platform to deal with the aggregation of all security threats, suspicious activities, and events to be filtered and prioritized for effective analysis and prompt decision making.<br><br>

(4) The complementing part of the above functionality is for the actioning of such events for immediate resolutions. This will enable common and well articulated activities to be resolved through automation. Less known activities to be dealt with custom playbooks and unknown activities to be dealt with direct intervention.<br><br>

(5) Constant evaluation of technological developments and updates in this sphere.<br><br>

Pertinent and overlapping technologies for detailed evaluation and consideration includes SIEM (Security Information and Event Management), EDR (Endpoint Detection and Response), XDR (eXtended Detection and Response), MDR (Managed Detection and Response), SOAR (Security Orchestration Automation and Response), etc.
`, 
  },
  { 
    id: 9, 
    date: "Saturday, October 31, 2020",
    title: "The Context For eCommerce", 
    image: bg, 
    description: `<b>Present Context</b><br>
There is no foreseeable control or ending to the raging global pandemic. This is driving the need and realization for online fulfillment and convenience.<br><br>

As the COVID-19 pandemic reshapes our world, more consumers have begun shopping online in greater numbers and frequency. According to new data from IBM’s U.S. Retail Index, the pandemic has accelerated the shift away from physical stores to digital shopping by roughly five years.<br><br>

In the first six months of the year, consumers spent $347.26 billion online with U.S. retailers, up 30.1% from $266.84 billion for the same period in 2019, according to the latest Digital Commerce 360 analysis of U.S. Department of Commerce data. Comparatively, eCommerce sales during the first half of 2019 grew just 12.7% year over year.<br><br>

Department stores, as a result, are seeing significant declines. In the first quarter of 2020, department store sales and those from other “non-essential” retailers declined by 25%. This grew to a 75% decline in the second quarter.<br><br>

Large retailers like Walmart and Target have embraced omnichannel fulfillment to their advantage. Both reported stellar earnings this month thanks to their earlier investments in e-commerce. In Walmart’s case, the pandemic helped drive e-commerce sales up 97% in its last quarter. Target set a sales record as its same-day fulfillment services grew 273% in the quarter. Amazon, naturally, has also benefited from the shift to digital with its recent record quarterly profit and 40% sales growth.<br><br>

This will drive a global/local trend that will evolve to be the new norm.<br><br>

<b>Some Facts Pertaining To Global eCommerce:</b><br>
- Global eCommerce revenue: 4.2 Trillion. It is estimated that there will be 2.05 billion global digital buyers by 2020.<br>
- The number #1 reason people shop online is that they’re able to shop at all hours of the day.<br>
- 81% of consumers conduct online research before making a purchase online.<br>
- 81% of consumers trust the advice of friends and family over businesses.<br>
- 65% of shoppers look up price comparisons on their mobile device while in a physical store.<br>
- 80% of people stop doing business with a company because of poor customer experience.<br>
- Consumers are most likely to trust a business that makes it easy to contact people at the company.<br>
- On average, only 2.86% of eCommerce website visits convert into a purchase.<br>
- 69% of shopping carts are abandoned. The unexpected extra cost is the number one reason shoppers abandon carts. Abandoned cart follow-up emails have an average open rate of 45%.<br>
- On average, 52% of online stores have omnichannel capabilities. This means they sell to and communicate with customers through multiple channels. For example, you might have a website, Facebook Shop, Instagram account, and an email list.<br>
- Nearly half (48%) of online shoppers simply head straight to a large eCommerce marketplace.<br>
- Mobile eCommerce is expected to account for 67.2% of digital sales in 2019. Users who have a negative experience on a mobile website are 62% less likely to purchase from that business in the future. Longer mobile page load times drastically increase bounces.<br>
- Younger people spend more time shopping online than older people.<br><br>

<b>Key Pillars For eCommerce Success:</b><br>

<b>1. #1 eCommerce Platform Software:</b><br>
- The need for ground-up development of eCommerce software is no longer a mandate due to the availability of robust platforms on both Open Source and Commercial Models.<br>
- The challenge lies in customizing these for the #1 UI/UX experience and seamless process integration from order to delivery.<br><br>

<b>2. Secure Hosting Infrastructure for Throughput and Scale:</b><br>
- Hosting infrastructure that can scale and perform within reasonable cost parameters.<br>
- Tier 1 cloud computing facilities are widely available at commodity pricing on utilization-based charging models.<br><br>

<b>3. Payment Gateway:</b><br>
- Many choices are available at affordable rates from PayPal to local offerings through banks and third-party establishments.<br><br>

<b>4. Delivery (Courier) Both Local and Overseas:</b><br>
- Many choices from global courier giants to local establishments for prompt local deliveries at affordable rates and published delivery cycles.<br><br>

<b>5. A Product Portfolio that Makes Sense for Online Commerce and Revenue:</b><br>
- Not all products are suitable for online commerce.<br>
- From the customer's perspective: Will they make an online purchase of a given product?<br>
- From the company’s perspective: Is it profitable to sell the item online from a cost, margin, and sales volume viewpoint?<br><br>

<b>6. Seamless Execution from Order to Delivery and Effective CRM:</b><br>
- The whole process needs to be executed with tier 1 quality and consistency, requiring perfect coordination between software, people, processes, and external entities.<br>
- Customer sentiment tracking and effective product portfolio relevance is essential.<br><br>

<b>7. Digital Marketing:</b><br>
- Digital marketing is crucial to create reach, visibility, and subtle influence for successful conversion into purchases through SEO, SERP, SEM, SMM, etc.<br><br>

<b>eCommerce Context in Sri Lanka:</b><br>
- Over the last decade, the pillars for effective eCommerce have evolved and are in place for capitalization.<br>
- Sri Lankan businesses should focus on capitalizing on the eCommerce platform to showcase exclusive/exotic produce/products for global/regional consumers.<br>
- Focusing on cheap imported substandard products will not be sustainable due to high competition and low margins.<br><br>

<b>Sources:</b><br>
- [TechCrunch](https://techcrunch.com)<br>
- [Digital Commerce 360](https://www.digitalcommerce360.com)`, 
  },
  { 
    id: 10, 
    date: "Wednesday, October 28, 2020",
    title: "Divergent Perspectives - Internet/eCommerce Statistics", 
    image: bg, 
    description: `The internet serves as an unparalleled global connector, offering boundless opportunities for those who are bold, brave, and creative. Consider the staggering statistics:<br><br>

<b>Key Figures</b><br><br>
Global Population: 8.1 Billion<br>
Mobile Users: 6.3 Billion (68%)<br>
Internet Users: 5.3 Billion (66%)<br>
Social Media Users: 4.9 Billion (60%)<br><br>

<b>Detailed Insights</b><br><br>
The average person spends 6 hours and 30 minutes online daily.<br>
There are approximately 1.7 billion websites worldwide.<br>
Global eCommerce generates $4.2 trillion in revenue.<br>
Predictions suggested 2.05 billion digital buyers worldwide by 2020.<br>
Convenience is the primary reason for online shopping, cited by 81% of consumers.<br>
81% of shoppers conduct online research before making a purchase.<br>
Consumer trust leans heavily towards recommendations from friends and family (81%).<br>
65% of shoppers compare prices on mobile devices while in physical stores.<br>
Poor customer experiences lead 80% of people to cease business with a company.<br>
Easy accessibility to company representatives fosters consumer trust.<br>
On average, only 2.86% of eCommerce website visits convert to purchases, with 69% of shopping carts abandoned due to unexpected additional costs.<br>
Abandoned cart follow-up emails achieve a 45% open rate.<br>
Approximately 52% of online stores embrace omni-channel capabilities.<br>
Nearly half (48%) of online shoppers prefer large eCommerce marketplaces.<br>
Mobile commerce accounts for 67.2% of digital sales.<br>
Negative mobile website experiences reduce future purchases by 62%.<br>
Lengthy mobile page load times significantly increase bounce rates.<br>
Younger demographics allocate more time to online shopping.<br><br>

<b>Summary</b><br><br>
Now is an optimal time to launch an online store.<br>
Businesses lacking online presence should establish one promptly.<br>
Prioritize convenience in customer experience; platforms like Facebook Shop can facilitate this.<br>
Utilize Google Shopping for product advertisement.<br>
Craft comprehensive product pages to address consumer queries.<br>
Leverage social proof to bolster trust and drive sales.<br>
Focus on stellar customer service to enhance retention.<br>
Continuously optimize website conversion rates.<br>
Streamline checkout processes to reduce cart abandonment.<br>
Minimize surprise fees and consider offering free shipping.<br>
Implement automated email campaigns for abandoned carts.<br>
Offer a seamless, personalized omni-channel experience.<br>
Create attention-grabbing ad designs.<br>
Build visitor trust through website optimization.<br>
Opt for mobile-optimized website themes.<br>
Improve website load speed by resizing images.<br>
Define and cater to a clear target market.
`, 
  },
  { 
    id: 11, 
    date: "Thursday, July 30, 2020",
    title: "IOT - The Next Frontier Of Online Expansion", 
    image: bg, 
    description: `The mobile is taking the Internet accessibility to the remaining frontiers of the global population.<br><br>

Initiatives such as Tesla's Star-link project aims for global accessibility of high-speed internet at affordable rates.<br><br>

Cloud-based computing is making it possible for ubiquitous real-time computing capability.<br><br>

The next phase of the internet expansion is now being driven to bring on board all equipment, devices, etc. for greater interaction, integration and experience through IoT enablement.<br><br>

By 2025, it is estimated that there will be more than 21 billion IoT devices.<br><br>

This makes it possible for the ability to manage, track, integrate and interact at a more cohesive and holistic manner. Brings about unprecedented capabilities and possibilities for the world at large.<br><br>

These are all made possible through supporting technologies which includes voice enablement, AI, Big Data, VR, AR, etc.
`, 
  },
  { 
    id: 12, 
    date: "Monday, July 27, 2020",
    title: "Voice - The Next Phase Of Digital Interaction", 
    image: bg, 
    description: `All major players are into it and also with many solutions.<br><br>

However, these are still at its infancy and are set to become mainstream in the days ahead.<br><br>

Voice will provide that next level of ease of interaction with Digital. While this will not replace the existing methods but will for sure carve out a significant share of human to digital interactions and will also extend to Digital to Digital Interactions.<br><br>

The possibilities of Digital to Digital interactions over voice will also loosen up the rigid coding level integration to a more extensible speech related models.<br><br>

Voice will enable a whole new world of possibilities.<br> 
For example<br>
* A CEO can just simply ask for the yesterday's sales and revenue figures while on holiday on a beachfront enjoying a cup of tea.<br>
* An HR manager can simply ask who is absent to work or on leave while driving his way to the office.<br><br>

Voice is set to dominate the enterprise as a key mechanism to interact with their digital assets for effective and instant updates and decision making.<br><br>

A potential platform we are currently looking into at PragICTS is Amazon's Alexa. We also expect to venture into the other major alternatives by both Microsoft, Google, etc.<br><br>

What is fueling these possibilities are primarily enabled by the rapid advancements in AI.
`, 
  },
  { 
    id: 13, 
    date: "Saturday, July 25, 2020",
    title: "'H' - The Hyped Part of HRM / HCM", 
    image: bg, 
    description: `While there has been notable progress in Human Resource Management (HRM) over recent decades, there remains a pervasive sense of unmet potential.<br><br>

HRM has often been entangled in public relations and marketing endeavors rather than earnestly considering how to strike a harmonious balance between the needs of employees and employers.<br><br>

The Dilemma:<br>
Employers prioritize extracting maximum output at minimal cost.<br>
Employees seek maximum rewards with minimal exertion.<br><br>

Though seemingly contradictory, deeper reflection reveals a nuanced line that warrants greater exploration.<br><br>

Perhaps the starting point lies in empathetically considering each party's perspective. Genuine empathy is paramount.<br><br>

A guiding principle to remember is that "Life is not just about work, and work is not just about life." The goal is sustained productivity and well-being while honoring this premise.<br><br>

Constructive measures such as strategic planning, training, automation, standardized processes, appropriate tools, and conducive work environments can contribute significantly to achieving these objectives, provided they are pursued with sincerity.<br><br>

Ultimately, the aim is to increase output efficiency with reduced effort.
`, 
  },
  { 
    id: 14, 
    date: "Saturday, July 25, 2020",
    title: "Open Source Or Commercial Software ?", 
    image: bg, 
    description: `The debate between open-source and commercial software is nuanced, with both options presenting their own advantages and drawbacks.<br><br>

Each has its own user base, deployments, and dedicated supporters, showcasing their respective strengths.<br><br>

Ultimately, the effectiveness of either depends on the specific context in which they're being considered.<br><br>

Neither option holds inherent superiority over the other; their suitability varies based on individual needs.<br><br>

When making a decision, key factors to consider include:<br>
Cost implications<br>
Availability of skilled personnel<br>
Ease of implementation and mastery<br>
Compatibility for integration and scalability<br>
Platform compatibility and interoperability<br><br>

It's crucial to approach the decision-making process objectively, avoiding being swayed by hype or one-sided marketing.<br><br>

Ultimately, the goal is to make an informed decision based on clear facts and considerations.
`, 
  },
  { 
    id: 15, 
    date: "Friday, July 24, 2020",
    title: "Online Presence - A Must Have", 
    image: bg, 
    description: `An online presence refers to the digital footprint or visibility that an entity maintains on the internet. While having a website or social media accounts can contribute to an online presence, simply having these platforms does not guarantee effective online visibility.<br><br>

Yes, having a website provides a foundational base for your online presence, offering a unique online address and location. Similarly, maintaining social media accounts can enhance your online presence by engaging with audiences on various platforms.<br><br>

However, merely having these platforms does not ensure online discoverability. To truly establish an online presence, an entity must be easily discoverable by its target audience through multiple channels:<br>
<b>Search:</b> Ensuring that your website and content are optimized for search engines, making it easier for users to find you through search queries.<br>
<b>Advertisements:</b> Utilizing online advertising platforms to reach and engage with target audiences effectively.<br>
<b>Content:</b> Creating high-quality and relevant content that resonates with your audience, increasing your visibility and credibility online.<br>
<b>Social Platforms:</b> Leveraging social media platforms to connect and interact with your audience, sharing content and engaging in conversations.<br><br>

By effectively leveraging these channels and ensuring discoverability across various online platforms, an entity can confidently claim to have established an online presence.
`, 
  },
  { 
    id: 16, 
    date: "Friday, July 24, 2020",
    title: "Keep It Simple", 
    image: bg, 
    description: `Simplicity is key to success, a principle that applies across all aspects of life, including IT and digital endeavors.<br><br>

In the fast-paced world of IT, constant innovation disrupts established practices. Striving for perfection in such a dynamic environment can be counterproductive.<br><br>

Choices abound in IT, making navigation through alternatives challenging. It requires both broad and deep knowledge, as well as a steady approach, to find pragmatic solutions that suit current and future needs.<br><br>

Every solution has its benefits and risks. Balancing engineering efforts to meet requirements without over or under-engineering is crucial.<br><br>

In essence, simplicity, adaptability, and balance are fundamental to achieving success in the ever-evolving landscape of IT.
`, 
  },
];

const Projects = () => {
  const [expandedProjectId, setExpandedProjectId] = useState(null);

  // Toggle function to expand/collapse description
  const toggleExpand = (id) => {
    setExpandedProjectId(expandedProjectId === id ? null : id);
  };

  // Truncate description to the first 4 lines
  const truncateDescription = (description, lines = 3) => {
    const lineBreaks = description.split('<br>').slice(0, lines).join('<br>');
    return lineBreaks;
  };

  return (
    <section data-scrollax-parent="true" id="projects">
      <div className="section-subtitle left-pos" data-scrollax="properties: { translateY: '-250px' }">
        <span>//</span>Blogs
      </div>

      <section data-scrollax-parent="true" id="sec1" style={{ padding: '50px 0' }}>
        <div className="container main-about">
          <div className="portfolio-grid-wrapper" style={{ marginTop: '30px' }}>
            <div className="portfolio-grid">
              {projects.map(project => (
                <div key={project.id} className="portfolio-item">
                  <div className="portfolio-details">
                    <p style={{ fontSize: '12px', textTransform: 'uppercase',fontWeight:'bold' }}>{project.date}</p>
                    <h4 style={{ fontSize: '18px', textTransform: 'uppercase', paddingBottom: '20px' }}>
                      {project.title}
                    </h4>

                    {/* Truncated or full description */}
                    <p style={{ fontSize: '12px', textTransform: 'uppercase', textAlign: 'justify' }}>
                      <span dangerouslySetInnerHTML={{ __html: expandedProjectId === project.id ? project.description : truncateDescription(project.description) }} />
                    </p>

                    {/* Expand/Shrink functionality */}
                    {expandedProjectId !== project.id && (
                      <button 
                        onClick={() => toggleExpand(project.id)} 
                        style={{ marginTop: '10px', backgroundColor: 'red', padding: '5px 10px' }}
                      >
                        Expand
                      </button>
                    )}

                    {expandedProjectId === project.id && (
                      <button 
                        onClick={() => toggleExpand(project.id)} 
                        style={{ marginTop: '10px', backgroundColor: 'red', padding: '5px 10px' }}
                      >
                        Collapse
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default Projects;
